
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

// import Mamber1 from "../images/client-1.webp";
// import Mamber2 from "../images/client-2.webp";
// import Mamber3 from "../images/client-3.webp";
// import Mamber4 from "../images/client-4.webp";
import React, { useState, useEffect } from "react";
import { URL } from "../../Redux/common/url";
const teamMembers = [
  {
    name: "John Doe",
    position: "CEO",
    image: "https://via.placeholder.com/150",
  },
  {
    name: "Jane Smith",
    position: "CTO",
    image: "https://via.placeholder.com/150",
  },
 
];

const TeamSlider = () => {
   const [productLists, setProductList] = useState([]);

  useEffect(() => {
    fetchProductList();
  }, []);

  const fetchProductList = async () => {
    try {
      const response = await fetch(
        `${URL.API_BASE_URL}/publicApi/teamListPublic`
      );
      if (response.ok) {
        const data = await response.json();
        console.log("API data:", data);
        setProductList(data?.team || []);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };
  return (
    <div className="container-fluid">
      <h1 className="fw-bold text-center mb-4 text-danger" style={{fontSize:"23px"}}>
        Our Trusted Team Experts
      </h1>

      <Swiper
        modules={[Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 1000, disableOnInteraction: false }} // 1 sec auto slide
        breakpoints={{
          576: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
        }}
      >
         {(productLists.length > 0 ? productLists : teamMembers).map(
          (item, index) => (
          <SwiperSlide key={index}>
           <div className="card shadow-sm text-center p-3 h-100">
  <div style={{ overflow: "hidden", borderRadius: "10px" }}>
    <img
      src={URL?.API_BASE_URL + item?.feature_image}
      alt={item.feature_image}
      style={{
        width: "100%",
        height: "200px",
        objectFit: "cover"
      }}
    />
  </div>

  <h5 className="fw-bold mt-3">{item.title}</h5>
  <p className="text-muted fw-bold">{item.short_description}</p>
</div>
          </SwiperSlide>
      )
        )}
      </Swiper>
    </div>
  );
};

export default TeamSlider;
